import { Dialog, DialogContent, TextField } from '@mui/material'
import WhiteButton from '../../../components/WhiteButton'
import BlueButton from '../../../components/BlueButton'
import CloseIcon from '@mui/icons-material/Close';
import SendIcon from '@mui/icons-material/Send';
import styles from './styles.module.css'
import { LoginContext } from '../../../config/Context/LoginContext'
import { useContext, useState } from 'react';
import { conviteParaParceiro } from '../../../services/api-planejamento-tributario.service';

const ModalEmailParceiro = ({ openModal, onClose }) => {
    const [email, setEmail] = useState(null)
    const [viewError, setViewError] = useState(false)
    const [viewSucess, setViewSucess] = useState(false)
    const { dadosLogin } = useContext(LoginContext)

    const handleSubmit = async () => {
        if (!email) {
            setViewError(true)
            setTimeout(() => {
                setViewError(false)
                return
            }, 3000)
        } else {
            try {
                const body = {
                    email: email,
                    idUsuarioPai: dadosLogin.idUsuario,
                    nomePai: dadosLogin.nome
                }
                await conviteParaParceiro(body)
                setViewSucess(true)
                setEmail(null)
                setTimeout(() => {
                    onClose()
                    setViewSucess(false)
                }, 15000);
            } catch (error) {
                console.log(error);
            }
        }
    }

    return (
        <Dialog
            open={openModal}
            onClose={onClose}
        >
            <DialogContent>
                {!viewSucess
                    ?
                    <>
                        <div className={styles.header}>
                            <h4>E-mail do Parceiro</h4>
                            <p>Digite abaixo o e-mail do parceiro que deseja cadastrar:</p>
                        </div>
                        <TextField
                            id="outlined-basic"
                            label="Email do Parceiro"
                            fullWidth
                            value={email}
                            type='email'
                            onChange={(e) => setEmail(e.target.value)}
                            error={!email}
                            size='small'
                            variant="outlined" />
                        {viewError
                            ? <p style={{ color: "#d43636" }}>Necessário digitar um e-mail.</p>
                            : ''
                        }
                        <div className={styles.buttons}>
                            <WhiteButton
                                textValue='Fechar'
                                contentIcon={<CloseIcon />}
                                clickFunction={onClose} />
                            <BlueButton
                                textValue='Enviar'
                                contentIcon={<SendIcon />}
                                clickFunction={handleSubmit} />
                        </div>
                    </>
                    : <>
                        <div className={styles.sucess}>
                            <h3>
                                E-mail enviado com sucesso!
                            </h3>
                            <p>
                                Agora é com o Parceiro! Peça para ele(a) verificar o e-mail e realizar o cadastro.
                            </p>
                            <p>Assim que o cadastro for concluido, ele aparecerá na sua tabela de Vinculos.</p>
                        </div>
                        <div className={styles.close_sucess}>
                            <WhiteButton
                                textValue='Fechar'
                                contentIcon={<CloseIcon />}
                                clickFunction={onClose} />
                        </div>
                    </>}
            </DialogContent>
        </Dialog>
    )
}

export default ModalEmailParceiro